import { useNavigate } from "react-router-dom";
import * as React from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import {
  Alert,
  createTheme,
  IconButton,
  ListItem,
  ListItemIcon,
  ListItemText,
  Snackbar,
  Stack,
} from "@mui/material";
import Button from "@mui/material/Button";
import OtpInput from "react-otp-input";
import { useEffect, useState } from "react";
import {
  GenerateOTPForForgotPassword,
  GetOTPForForgotPassword,
} from "../../../api";
import useStyles from "../../../css/styles";
import { ArrowBack } from "@mui/icons-material";
import useMediaQuery from "@mui/material/useMediaQuery";

// Update log
// FB  6192   02/06/2023  DK  Added page to handle verification in forgot password
// FB  7085   07/27/2023  GS  Clearing OTP field when it expires
// FB  7469   09/27/2023  SK   Patient Portal - Replace Doctor Direct with License Name , Update logo in Payment Receipt , Change in texts in Home Page

export default function ForgotPasswordVerification() {
  const matches = useMediaQuery("(min-width:600px)");
  const navigate = useNavigate();
  const [isCodesent, setIsCodesent] = useState(false);
  const [sendEmail, setSendEmail] = useState(0);
  const [sendText, setSendText] = useState(0);
  const styles = useStyles();
  const validOTPlength = 6;
  const [OTP, setOTP] = useState("");
  const [seconds, setSeconds] = useState(0);
  const [minutes, setMinutes] = useState(2);
  const [isOTPErrored, setIsOTPErrored] = useState(false);
  const [isTimeOut, setIsTimeOut] = useState(false);
  const [isCodeResent, setIsCodeResent] = useState(false);
  const [snackbarConfig, setSnackbarConfig] = React.useState({
    open: false,
    message: "",
    severity: "success",
  });
  const stylestart = {
    container: {
      border: "1px grey",
      marginTop: "40px",
      display: isCodesent ? "none" : "flex",
      paddingLeft: matches == false ? "20px" : "80px",
      marginBottom: "40px",
      minHeight: "70vh",
    },
  };
  const data = sessionStorage.getItem("PatientContact");
  if (data != null) {
    var patientContact = JSON.parse(data);
    var login = patientContact.login;
    var patientPhone = patientContact.patientCellPhone;
    var patientEmail = patientContact.patientEmail;
  }

  const emrData = sessionStorage.getItem("EMRConfig");
  if (emrData != null) {
    var websiteDetails = JSON.parse(emrData);
    var websiteID = websiteDetails.WebsiteID;
  }

  const theme = createTheme({
    palette: {
      primary: {
        main: "#18a2b8",
      },
    },
  });

  const handleOTPInput = (value: any) => {
    setOTP(value);
  };

  async function Sendcode(isSendText: number, isSendMail: number) {
    if (isSendText) {
      setSendText(1);
    }
    if (isSendMail) {
      setSendEmail(1);
    }
    await GenerateOTPForForgotPassword(login, isSendText, isSendMail, websiteID)
      .then((data) => {
        setIsCodesent(true);
        setMinutes(2);
        setSeconds(0);
        setSnackbarConfig({
          open: true,
          message: "Code sent successfully!",
          severity: "success",
        });
      })
      .catch((error) => error);
  }

  async function ReSendCode() {
    await GenerateOTPForForgotPassword(login, sendText, sendEmail, websiteID)
      .then((data) => {
        setIsCodeResent(true);
        setIsOTPErrored(false);
        setIsTimeOut(false);
        setMinutes(2);
        setSnackbarConfig({
          open: true,
          message: "Code re-sent successfully!",
          severity: "success",
        });
      })
      .catch((error) => error);
  }

  const handleVerifyCode = async (e: any) => {
    e.preventDefault();
    await GetOTPForForgotPassword(login)
      .then((data) => {
        if (data == OTP) {
          setSnackbarConfig({
            open: true,
            message: "Code verified successfully!",
            severity: "success",
          });
          navigate("/user/resetpassword");
        } else {
          setOTP("");
          setIsOTPErrored(true);
        }
      })
      .catch((error) => error);
  };

  function updateTime() {
    if (minutes == 0 && seconds == 0) {
      setIsTimeOut(true);
      setOTP(""); //FB 7085
      setIsOTPErrored(false);
    } else {
      if (seconds == 0) {
        setMinutes((minutes) => minutes - 1);
        setSeconds(59);
      } else {
        setSeconds((seconds) => seconds - 1);
      }
    }
  }

  function formatPhone(phonenumber: string) {
    if (phonenumber != "" && phonenumber != null && phonenumber != undefined) {
      phonenumber = phonenumber.replace(/[^0-9]/g, "");
      phonenumber =
        "(" +
        phonenumber.slice(0, 3) +
        ") " +
        phonenumber.slice(3, 6) +
        "-" +
        phonenumber.slice(6, 10);
      phonenumber = phonenumber.replace(/^(.{0})[^-]+/, "$1******");
    } else {
      phonenumber = "";
    }
    return phonenumber;
  }

  useEffect(() => {
    const token = setTimeout(updateTime, 1000);

    return function cleanUp() {
      clearTimeout(token);
    };
  }, [minutes, seconds]);

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    setSnackbarConfig({ open: false, message: "", severity: "success" });
  };
  const handlegoback = () => {
    setIsCodesent(false);
    setIsCodeResent(false);
    setSendEmail(0);
    setSendText(0);
  };

  //FB 7469 - Begin
  const [HeaderText, setHeaderText] = useState("");

  async function LoadHeaderText() {
    let setting = sessionStorage.getItem("LicenseeName");
    if (setting != null) {
      setHeaderText(setting);
    }
  }

  useEffect(() => {
    LoadHeaderText();
  }, []);
  //FB 7469 - End

  return (
    <>
      <div className="card" style={stylestart.container}>
        <h4 style={{ textAlign: "left" }}>
          Recover your {HeaderText} Password
        </h4>{/* FB 7469 */}
        <br></br>
        <h5 style={{ textAlign: "left" }}>Verify your Identity</h5>
        <a style={{ textAlign: "left" }}>
          Our goal is to make sure your health information is safe and secure.
          You will now be required to enter a one-time use security code to
          verify your identity.
        </a>
        <a href="/Dashboard" style={{ textAlign: "left" }}>
          Learn More
        </a>
        <br></br>
        <h4 style={{ textAlign: "left" }}>
          How would you like to receive the code?
        </h4>
        <br></br>
        <div style={{ display: "flex", justifyContent: "left" }}>
          <Button
            variant="contained"
            className={styles.navigationButton}
            style={{
              display: formatPhone(patientPhone) != "" ? "flex" : "none",
              marginLeft: 5,
            }}
            onClick={() => Sendcode(1, 0)}
          >
            Text to my phone
          </Button>
          <Button
            variant="contained"
            className={styles.navigationButton}
            style={{
              display:
                patientEmail != null || patientEmail != "" ? "flex" : "none",
              marginLeft: 5,
            }}
            onClick={() => Sendcode(0, 1)}
          >
            Send to my email
          </Button>
        </div>
      </div>
      <form onSubmit={handleVerifyCode}>
        <Grid
          container
          spacing={2}
          style={{
            display: isCodesent ? "flex" : "none",
            paddingLeft: matches == false ? "20px" : "80px",
            marginBottom: matches == false ? "80%" : "0px",
          }}
        >
          <Grid item xs={12}>
            <ListItem>
              <ListItemIcon>
                <IconButton onClick={handlegoback}>
                  <ArrowBack />
                </IconButton>
              </ListItemIcon>
              <ListItemText>
                <Typography variant="h5">
                  <b>Confirm your identity</b>
                </Typography>
              </ListItemText>
            </ListItem>
          </Grid>
          <Grid item xs={12}>
            <Typography>
              Please enter the code we sent to{" "}
              {sendEmail === 1
                ? patientEmail.replace(/^(.{1})[^@]+/, "$1******")
                : formatPhone(patientPhone)}
              .
            </Typography>
          </Grid>
          <br />
          <Grid
            item
            xs={12}
            style={{
              display: "flex",
              alignContent: "center",
              justifyContent: "center",
            }}
          >
            <Typography style={{ display: !isTimeOut ? "flex" : "none" }}>
              {minutes + "m " + seconds + "s left"}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <OtpInput
              value={OTP}
              onChange={handleOTPInput}
              numInputs={validOTPlength}
              separator={<span>-</span>}
              isInputNum={true}
              inputStyle={styles.otp}
              shouldAutoFocus
              hasErrored={isOTPErrored}
              errorStyle={styles.otpError}
              isDisabled={isTimeOut ? true : false}
            />
          </Grid>
          <Grid item xs={6} sm={3} md={2}>
            <Button
              type="submit"
              variant="contained"
              className={
                OTP.length < validOTPlength
                  ? styles.disabledButton
                  : styles.navigationButton
              }
              disabled={OTP.length < validOTPlength ? true : false}
              //onClick={handleVerifyCode}
              style={{ marginLeft: 5 }}
            >
              Confirm
            </Button>
          </Grid>
          <Grid item xs={6} sm={3} md={2}>
            <Button
              variant="contained"
              className={styles.navigationButton}
              style={{ display: isTimeOut ? "flex" : "none", marginLeft: 5 }}
              onClick={ReSendCode}
            >
              Resend code
            </Button>
          </Grid>
        </Grid>
      </form>
      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          open={snackbarConfig.open}
          autoHideDuration={6000}
          onClose={handleClose}
        >
          <Alert
            onClose={handleClose}
            severity={
              snackbarConfig.severity === "success" ? "success" : "error"
            }
            sx={{ width: "100%" }}
          >
            {snackbarConfig.message}
          </Alert>
        </Snackbar>
      </Stack>
    </>
  );
}

const button = {
  container: {
    backgroundColor: "#13607C",
    color: "white",
  },
};

const text = {
  container: {
    borderRadius: "5px",
    height: "35px",
  },
};
